<nav class="rp" [attr.aria-label]="rotulo">
  <ol class="rp-lista">
    <li *ngFor="let p of pasos; let i = index; let ultimo = last" class="rp-paso"
        [class.rp-hecho]="p.estado === 'HECHO'" [class.rp-actual]="p.estado === 'ACTUAL'"
        [class.rp-fallo]="p.estado === 'FALLO'" [attr.aria-current]="p.estado === 'ACTUAL' ? 'step' : null">
      <button type="button" class="rp-boton" [disabled]="!navegable || p.estado === 'PENDIENTE'" (click)="tocar(p)">
        <span class="rp-marca" aria-hidden="true" [class.kb-texto-exito]="p.estado === 'HECHO'" [class.kb-texto-peligro]="p.estado === 'FALLO'">
          <i *ngIf="p.estado === 'HECHO'" class="fas fa-check"></i>
          <i *ngIf="p.estado === 'FALLO'" class="fas fa-times"></i>
          <span *ngIf="p.estado === 'ACTUAL' || p.estado === 'PENDIENTE'">{{ i + 1 }}</span>
        </span>
        <span class="rp-texto">
          <span class="rp-nombre" [class.kb-texto-peligro]="p.estado === 'FALLO'">{{ p.nombre }}</span>
          <span class="rp-detalle" *ngIf="p.detalle">{{ p.detalle }}</span>
        </span>
      </button>
      <span class="rp-linea" *ngIf="!ultimo" aria-hidden="true"></span>
    </li>
  </ol>
</nav>
